var render = function render(){
  var _vm$controller, _vm$controller2, _vm$controller3, _vm$controller4, _vm$controller5, _vm$controller6, _vm$controller7, _vm$controller8, _vm$controller9;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": true,
      "max-width": "700px"
    },
    on: {
      "click:outside": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-card-title', {
    staticClass: "py-4 px-6 d-flex justify-space-between align-center"
  }, [_c('span', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v("Vezérlői műveletek")]), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticClass: "px-6 pb-5 pt-1"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Eszköz név / Alias")]), _c('div', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s((_vm$controller = _vm.controller) === null || _vm$controller === void 0 ? void 0 : _vm$controller.controller_name) + " (" + _vm._s(((_vm$controller2 = _vm.controller) === null || _vm$controller2 === void 0 ? void 0 : _vm$controller2.alias) || '-') + ")")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Sorozatszám")]), _c('div', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s(((_vm$controller3 = _vm.controller) === null || _vm$controller3 === void 0 ? void 0 : _vm$controller3.serial_number) || 'N/A'))])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Helyszín")]), _c('div', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s((_vm$controller4 = _vm.controller) === null || _vm$controller4 === void 0 ? void 0 : _vm$controller4.building_name) + ", " + _vm._s((_vm$controller5 = _vm.controller) === null || _vm$controller5 === void 0 ? void 0 : _vm$controller5.building_level_name))])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Kapcsolat adatai")]), _c('div', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s((_vm$controller6 = _vm.controller) === null || _vm$controller6 === void 0 ? void 0 : _vm$controller6.connection_name))]), _c('div', {
    staticClass: "text-body-2 primary--text font-weight-bold"
  }, [_vm._v(_vm._s((_vm$controller7 = _vm.controller) === null || _vm$controller7 === void 0 ? void 0 : _vm$controller7.ip) + ":" + _vm._s((_vm$controller8 = _vm.controller) === null || _vm$controller8 === void 0 ? void 0 : _vm$controller8.port))])]), _c('div', [_c('div', {
    staticClass: "text-caption"
  }, [_vm._v("Típus")]), _c('div', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s((_vm$controller9 = _vm.controller) === null || _vm$controller9 === void 0 ? void 0 : _vm$controller9.controller_type))])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "text-body-3 mb-2"
  }, [_vm._v("Műveletek")]), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mb-2 py-5",
          attrs: {
            "color": "primary",
            "block": "",
            "depressed": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('restart', _vm.controller);
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-refresh")]), _vm._v(" Újraindítás ")], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Eszköz szoftveres újraindítása")])]), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mb-2 py-5",
          attrs: {
            "color": "primary",
            "block": "",
            "depressed": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('powerCycle');
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-power-cycle")]), _vm._v(" Power Cycle ")], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Tápellátás megszakítása és visszakapcsolása")])]), _c('v-btn', {
    staticClass: "mb-2 py-5",
    attrs: {
      "color": "primary",
      "block": "",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('uploadCards', _vm.controller);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-package-up")]), _vm._v(" Kártyák feltöltése ")], 1), _c('v-btn', {
    staticClass: "mb-2 py-5",
    attrs: {
      "color": "primary",
      "block": "",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('deleteCards', _vm.controller);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" Kártyák törlése ")], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }